import { SUPPLIER_AREAS, isSupplierRoute } from "../../router.js";
import type { Route, SupplierArea } from "../../router.js";
import { readChoice, rememberValue, userKey } from "../../browserMemory.js";

/**
 * Der zuletzt ANGEZEIGTE Reiter des Einkaufs (Entscheid 516b; Fixrunde 1, Ruling W1): Der Navigationseintrag
 * „Einkauf“ führt dorthin, wenn man in einem anderen Bereich steht. Gemerkt je Benutzer im Browser — eine Bequemlichkeit
 * des Geräts, keine Einstellung des Kontos (`browserMemory.ts`).
 */
export const PURCHASING_TAB_KEY = "ki-purchasing-tab";

/** Vorgabe ohne Merken: „Lieferverträge“, der erste Reiter. */
export const PURCHASING_TAB_DEFAULT: SupplierArea = "liefervertraege";

export function readPurchasingTab(userId: string | undefined): SupplierArea {
  return readChoice(userKey(PURCHASING_TAB_KEY, userId), SUPPLIER_AREAS, PURCHASING_TAB_DEFAULT);
}

/**
 * Wohin „Einkauf“ führt: im Einkauf der ANGEZEIGTE Reiter — ein Klick auf den aktiven Eintrag wechselt ihn nie, auch
 * bevor `PurchasingArea` ihn nach dem Zeichnen gemerkt hat —, sonst der zuletzt angezeigte (Fixrunde 1, Ruling W1).
 */
export function purchasingTabFor(route: Route, userId: string | undefined): SupplierArea {
  return isSupplierRoute(route) ? route.name : readPurchasingTab(userId);
}

/** Merkt den Reiter für den nächsten Klick auf „Einkauf“ aus einem anderen Bereich. */
export function rememberPurchasingTab(tab: SupplierArea, userId: string | undefined): void {
  rememberValue(userKey(PURCHASING_TAB_KEY, userId), tab);
}
